import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

type MutuPromptProps = {
  verb: string
  subject: ReactNode
  className?: string
}

export function MutuPrompt({ verb, subject, className }: MutuPromptProps) {
  return (
    <p
      className={cn(
        "font-mono text-[10px] text-brand uppercase tracking-[0.45em]",
        className
      )}
    >
      Mutu&nbsp;&gt; <span className="text-label">{verb}</span>{" "}
      <span className="text-label-dim">&gt;</span>{" "}
      <span className="text-white">{subject}</span>
    </p>
  )
}
